import {
  GET_LIST_TICKET,
  GET_LIST_TICKET_SUCCESS,
  GET_LIST_TICKET_FAILURE,
} from "../../actions/Ticket/actionTypes";

const initialState = {
  List: [],
  TTotalQuantity: 0,
};
const getListTicket = (state, action) => ({
  ...state,
  getListTicketLoading: true,
});

const getListTicketSuccess = (state, action) => {
  return {
    ...state,
    List: action.payload.TicketResults,
    Totals: action.payload.Totals,
    TotalChuaXem: action.payload.TotalChuaXem,
    getListTicketLoading: false,
  };
};

const getListTicketFailed = (state, action) => ({
  ...state,
  getListTicketLoading: false,
  List: [],
});
export const listTicketReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_TICKET:
      return getListTicket(state, action);
    case GET_LIST_TICKET_SUCCESS:
      // alert("tuty");
      return getListTicketSuccess(state, action);
    case GET_LIST_TICKET_FAILURE:
      //alert('false')
      return getListTicketFailed(state, action);
    default:
      return state;
  }
};

export default listTicketReducer;
